<app-progress-bar *ngIf="loading"></app-progress-bar>
<div *ngIf="!loading" class="container mt-3">
  <!--<p>ID del Estudiante: {{ authService.iduser }}</p>
  <p>Rol: {{ authService.rol }}</p>
  <button type="button" class="btn btn-primary" routerLink="/addpractice">Crear nueva practica</button>-->
  <div class="row mb-3">
    <div class="col-8 col-md-6">
      <h4>Listado de practicas</h4>
    </div>
  </div>

  <div class="table-responsive" *ngIf="listPractices.length > 0">
    <table class="table table-hover">
      <thead>
        <tr>
          <th scope="col">Accion</th>
          <th scope="col">Gestion</th>
          <th scope="col">Carrera</th>
          <th scope="col">Centro</th>
          <th scope="col">Area</th>
          <th scope="col">Turno</th>
          <th scope="col">Vacantes</th>
          <th scope="col">Inscritos</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of listPractices" class="table-active">
          <td>
            <!--<button (click)="addPractice(authService.iduser!, item.id!)" type="button" class="btn btn-primary btn-sm">Inscribir</button>-->
            <button
              (click)="addPractice(item.id!)"
              type="button"
              class="btn btn-primary btn-sm"
              [disabled]="isLoading || isAlreadyEnrolled(item.id!) || getAvailableSlots(item) <= 0">
              {{ isLoading && selectedPracticeId === item.id ? 'Inscribiendo...' : 'Inscribir' }}
            </button>
          </td>
          <td>{{ item.namemanagement }}</td>
          <td>{{ item.namecareer }}</td>
          <td>{{ item.namecenter }}</td>
          <td>{{ item.namearea }}</td>
          <td>{{ item.nameturn }}</td>
          <td>{{ item.quota }}</td>
          <td>{{ item.enrolled }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <h5 *ngIf="listPractices.length == 0 && !loading">No hay practicas para mostrar</h5>
</div>
